import { filterOnlyHits } from './byResultTypes.js';
import {
    filterOnlyMatchingTagId, filterOnlyMatchingBatterHandedness, filterOnlyMatchingPitcherHandedness
} from './byParameterValue.js';
import { filterWithDateBetween } from './byResultDate.js';

const buildFiltersForHittingSummary = function({
    batterIds, batterHandedness, pitcherHandedness,
    // date range filtering
    dateFrom, dateTo,// season,
}){
    batterIds = batterIds || [];
    batterHandedness = batterHandedness || '';
    pitcherHandedness = pitcherHandedness || '';

    let hittingSummaryFilters = filterOnlyHits();
     //   .concat(filterOnlyHavingValueEqualTo( 
     //       ResultData.PitchId.key, 0
      //  ));

    if (batterIds && batterIds.length){
        hittingSummaryFilters = hittingSummaryFilters.concat(filterOnlyMatchingTagId(batterIds));
    }
    if (batterHandedness){
        hittingSummaryFilters = hittingSummaryFilters.concat(filterOnlyMatchingBatterHandedness(batterHandedness));
    }
    if (pitcherHandedness){
        hittingSummaryFilters = hittingSummaryFilters.concat(filterOnlyMatchingPitcherHandedness(pitcherHandedness));
    }

    if (dateFrom || dateTo) {
        // TODO - check if it's Date type
        hittingSummaryFilters = hittingSummaryFilters.concat(filterWithDateBetween(dateFrom, dateTo));
    }

    return hittingSummaryFilters;
};

export default buildFiltersForHittingSummary;